export const RatioIcon = ({title}:any) => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        {title && <title>{title}</title>}
        <path d="M1.23446 2.09352V6.13811H0V0H6.13811V1.23446H2.09352L15.7655 14.9065V10.8619H17V17H10.8619V15.7655H14.9065L1.23446 2.09352Z" fill="#4A4B57" />
    </svg>
)